import { BreakpointObserver } from '@angular/cdk/layout';
import { StepperOrientation, STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { Component, inject, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/auth/auth.service';
import { SppdashboardService } from '../../dashboard/sppdashboard.service';
import { HelpdeskService } from '../../admin/helpdesk/helpdesk.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { distinctUntilChanged, map, Observable } from 'rxjs';
import { urlValidator } from '../../../utils/urlvalidator';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import { environment } from 'src/environments/env';
import { employmentTypeList, namewithSpace } from 'src/app/utils/constants';
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';
import { UserDataModalComponent } from 'src/app/component/user-data-modal/user-data-modal.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import Utils from 'src/app/utils/utils';

@Component({
  selector: 'app-iscpforms',
  standalone: false,
  templateUrl: './iscpforms.component.html',
  styleUrl: './iscpforms.component.scss',

  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false, showError: true },
    }
  ]
})
export class ISCPFormsComponent implements OnInit {

  @ViewChild('stepper') stepper!: MatStepper;
  @ViewChild('stepperLin') stepperLin!: MatStepper;
  public stepperOrientation!: Observable<StepperOrientation>;
  public horizLinPersonalInfo: any;
  public horizLinFavoriteThings: any;
  public loggedUserDetails: any;
  public status: any;
  @Input() isFromRenewal: boolean | null = null;
  public formSubmitted: boolean = false;
  public isCheckboxSelected = false;
  public show: boolean = false;
  public employmentTypeList: any = employmentTypeList;
  public iscpProviderList: any = [];
  public selectediscpProvider: any;
  disableSubmitButton: boolean = false;
  public isAgreementLinkDisabled: boolean = true;
  public isFTEuser: boolean = false;
  public dialogConfig: any = {};
  public simpleDialog!: MatDialogRef<UserDataModalComponent>;
  public snackbar = inject(MatSnackBar);

  @Input() countryList: any;
  @Input() languageList: any;

  icons = {
    faArrowLeft,
    faInfoCircle
  }


  public constructor(
    private readonly _fb: FormBuilder,
    private readonly router: Router,
    breakpointObserver: BreakpointObserver,
    private readonly _auth: AuthService,
    private readonly sppdashboardService: SppdashboardService,
    private readonly helpService: HelpdeskService,
    private readonly dialogModel: MatDialog,
    private readonly util: Utils, 
  ) {
    this.stepperOrientation = breakpointObserver
      .observe('(min-width: 600px)')
      .pipe(map(({ matches }) => (matches ? 'horizontal' : 'vertical')));
  }



  ngOnInit(): void {
    this.initializeForms();
    this.getLoggedInUserDetailsSubject();
    this.getIscpProviderList();
    this.isFTEuser = this._auth.getIsFTEuserValue();
    console.log("#FTEYesAction--", this.isFTEuser);
  }

  private getLoggedInUserDetailsSubject(): void {
    // Get the Logged in user Details
    this._auth.getLoggedInUserDetails().pipe(distinctUntilChanged((prev: any, curr: any) => JSON.stringify(prev) === JSON.stringify(curr)))
      .subscribe((res: any) => {
        if (res) {
          this.loggedUserDetails = res;
          this.status = res.status;
          this.initializeForms();
        }
      });
  }

  private initializeForms(): void {
    this.horizLinPersonalInfo = this._fb.group({
      firstname: [{ value: '', disabled: true }, [Validators.required, Validators.pattern(namewithSpace)]],
      lastname: [{ value: '', disabled: true }, [Validators.required, Validators.pattern(namewithSpace)]],
      iscpProvider: [{ value: '', disabled: true }, Validators.required],
      iscpreferCode: [{ value: '', disabled: true }],
      iscpDetails: [{ value: '', disabled: true }],
      transScriptUrl: [{ value: '', disabled: true }, [Validators.required, urlValidator]],
      alternateEmail: [{ value: '', disabled: true }, [this.util.customEmailValidator]],
      email: [{ value: sessionStorage.getItem('email'), disabled: true }],
    });


    this.horizLinFavoriteThings = this._fb.group({
      language: [{ value: '', disabled: true }, Validators.required],
      country: [{ value: '', disabled: true }, Validators.required],
      employmentType: [{ value: '', disabled: true }, [Validators.required, this.fteEmploymentValidator()]],
      mctAgreement: [{ value: '', disabled: true }, Validators.required],
    });


    const editableStatuses = ['REJECT', 'FIRST_LOGIN', 'EXPIRED', 'ALUMNI'];
    if (editableStatuses.includes(this.status)) {
      this.horizLinPersonalInfo.enable();
      this.horizLinFavoriteThings.enable();
      this.isAgreementLinkDisabled = false;
    }

    this.horizLinPersonalInfo.get('email')?.disable();
    this.horizLinFavoriteThings.get('mctAgreement')?.disable();

    const patchableStatuses = ['FIRST_LOGIN', 'OPEN', 'REJECT', 'EXPIRED', 'REINSTATE_SUBMIT', 'REINSTATE_REJECT', 'ALUMNI'];
    if (patchableStatuses.includes(this.status)) {
      this.horizLinPersonalInfo.patchValue({
        firstname: this.loggedUserDetails.firstname,
        lastname: this.loggedUserDetails.lastname,
        email: this.loggedUserDetails.email,
        iscpProvider: this.loggedUserDetails.iscpProviderCode,
        iscpreferCode: this.loggedUserDetails.iscpReferCode,
        iscpDetails: this.loggedUserDetails.iscpDetails,
        transScriptUrl: this.loggedUserDetails.transScriptUrl,
        alternateEmail: this.loggedUserDetails.alternateEmail
      });

      this.horizLinFavoriteThings.patchValue({
        language: this.loggedUserDetails.language,
        country: this.loggedUserDetails.country,
        employmentType: this.loggedUserDetails.employmentType,
      });
      
      if(this.status === 'OPEN' || this.status === 'REJECT' || this.status === 'REINSTATE_SUBMIT' || this.status === 'REINSTATE_REJECT') {
          this.isCheckboxSelected = true; 
      }
    }
  }



  submit() {
    this.formSubmitted = true;
    this.horizLinPersonalInfo.markAllAsTouched();
    this.horizLinFavoriteThings.markAllAsTouched();

    if (this.formSubmitted && this.horizLinPersonalInfo.valid && this.horizLinFavoriteThings.valid && this.isCheckboxSelected) {
      this.disableSubmitButton = true;

      const payload = {
        firstname: this.horizLinPersonalInfo.value.firstname,
        lastname: this.horizLinPersonalInfo.value.lastname,
        transScriptUrl: this.horizLinPersonalInfo.value.transScriptUrl,
        alternateEmail: this.horizLinPersonalInfo.value.alternateEmail,
        iscpProviderCode: this.selectediscpProvider ? this.selectediscpProvider.code : localStorage.getItem('iscpProviderCode'),
        iscpProviderName: this.selectediscpProvider ? this.selectediscpProvider.name : localStorage.getItem('iscpProviderName'),
        iscpReferCode: this.horizLinPersonalInfo.value.iscpreferCode,
        iscpDetails: this.horizLinPersonalInfo.value.iscpDetails,
        language: this.horizLinFavoriteThings.value.language,
        country: this.horizLinFavoriteThings.value.country,
        employmentType: this.horizLinFavoriteThings.value.employmentType,
        mctAgreement: this.horizLinFavoriteThings.value.mctAgreement,
      }

      this.sppdashboardService.submitISCPForm(payload, sessionStorage.getItem('email')).subscribe({
        next: (res: any) => {
          if (res.success) {
            this.formSubmitted = false;
            sessionStorage.setItem('firstname', this.horizLinPersonalInfo.value.firstname);
            sessionStorage.setItem('lastname', this.horizLinPersonalInfo.value.lastname);
            this._auth.setLoggedInUserDetails(res.data);
            this.ModalOnSubmitForm(res);
            this.sendEmail();
          } else {
            this.disableSubmitButton = false;
          }
        }, error: (error: any) => {
          this.disableSubmitButton = false;
        }
      });
    }
  }

  sendEmail(): void {
    if (this.horizLinPersonalInfo.getRawValue()?.email) {
      const tempObject = {
        "recipientEmail": this.horizLinPersonalInfo.getRawValue()?.email,
        "subject": 'MCT Enrollment Submission Notification',
        "templateName": 'MCTAppReceived',
        "language": "en",
        "customContext": "{}"
      }

      this.helpService.sendEmail(tempObject).subscribe((res: any) => {
        if (res.success) {
           /* empty */ 
          }
      }, (error: any) => {
        const errMsg = error?.error?.errors ? error?.error?.errors : [error?.error?.error];
        errMsg?.map((msg: string) => {
          this.snackbar.open(msg, '', { verticalPosition: 'top', horizontalPosition: 'right', panelClass: ['warning'] });
        });
      })
    }
  }


  ModalOnSubmitForm(res: any) {

    if(res.data.status === 'TEST_OUT_OPEN'){ 

      res.message = `Thank you for submitting your application.<br/>
                      You may now proceed to the MCT Instructional Skills Assessment. Once payment is completed and the assessment is passed, you can complete your MCT Program enrolment. <br/>
                      For questions, please contact us at <a aria-label="Email MCT Support at mctpvsupport@pearson.com" href="mailto:mctpvsupport@pearson.com">mctpvsupport&#64;pearson.com</a> - we’re here to help!`;
      res.title = 'Your application has been submitted.';
      res.userSelectedFlow = 'ISCPFlow';      
    } else {
      res.message = `Thank you for submitting your application to become a Microsoft Certified Trainer.  <br/>
              Your application is under review, and additional information regarding next steps will be provided via email within 3-5 business days.
              <br/>
              For questions, please contact us at <a aria-label="Email MCT Support at mctpvsupport@pearson.com" href="mailto:mctpvsupport@pearson.com">mctpvsupport&#64;pearson.com</a> - we’re here to help!`;
      res.title = 'Your application has been submitted.';
      res.userSelectedFlow = 'ISCPFlow';
    }

    this.dialogConfig.value = res;

    this.simpleDialog = this.dialogModel.open(UserDataModalComponent, { data: this.dialogConfig });
    this.simpleDialog.afterClosed().subscribe({
      next: (result) => {
        if (result) {
          if (result === 'trainingSelection') {
            this.disableSubmitButton = false; // Enable Submit button for any future use without refreshing the page
          }
        }
      },
      error: (error) => {
        console.error('Error in dialog:', error);
      },
      complete: () => {
        console.log('Dialog closed');
      }
    });
  }


  private fteEmploymentValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (this.isFTEuser && control.value && control.value !== 'ACTIVE_MICROSOFT_EMPLOYEE') {
        return { fteEmploymentType: true };
      }
      return null;
    };
  }

  agrementDoc = () => {
    this.horizLinFavoriteThings.get('mctAgreement')?.enable();
    const pdfUrl = environment.BASE_URL + `/ptp/api/spp/mct/mct_agreement/download`;
    window.open(pdfUrl, '_blank');
  }


  next() {
    this.horizLinPersonalInfo.markAllAsTouched();
    this.horizLinPersonalInfo.updateValueAndValidity();
  }

  previous() {
    this.router.navigate(['/expired-mct']);
  }

  getIscpProviderList = () => {
    this.sppdashboardService.getIscpProviderList('', '').subscribe((response: any) => {
      if (response.success) {
        this.iscpProviderList = response.data.content;
        this.onSelectionChange({ value: this.loggedUserDetails.iscpProviderCode });
      } else {
        console.log("Error fetching ISCP Provider List");
      }
    }, (error: any) => {
      console.error("Error fetching ISCP Provider List", error);
    });
  }

  getTranscript() {
    const pdfUrl = environment.BASE_URL + `/ptp/api/spp/mct/How_to_access_your_Learn_Transcript/download`;
    window.open(pdfUrl, '_blank');
  }

  onClickTesturl() {
    const url = this.horizLinPersonalInfo.get('transScriptUrl').value;
     if (this.isSafeUrl(url)) {
    window.open(url, '_blank', 'noopener,noreferrer');
  } else {
    console.warn('Blocked untrusted redirect target:', url);
    // optionally show a user-facing error/toast
  }
  }

  // private readonly allowedHosts = ['pvue2.com', 'pearsonvue.com'];

  private isSafeUrl(url: string): boolean {
 try {
    // 1. If it doesn't start with a protocol, native URL constructor might fail.
    // Ensure we are working with an absolute URL.
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      return false;
    }

    const parsedUrl = new URL(url);

    // 2. Strict Protocol Whitelist (Blocks javascript: and data: protocols)
    const allowedProtocols = ['https:', 'http:'];
    if (!allowedProtocols.includes(parsedUrl.protocol)) {
      return false;
    }

    // 3. Since Microsoft Learn transcripts belong to any domain, we allow all hostnames
    // but ensure the hostname is structurally present and valid.
    return parsedUrl.hostname.length > 0;
  } catch (e) {
    // If the URL constructor throws an error, the URL is malicious or malformed.
    return false;
  }
}

  onSelectionChange(event: any) {
    if (event.value) {
      this.selectediscpProvider = this.iscpProviderList?.filter((iscp: any) => iscp.code === event.value)[0];
    }
  }


}
